import WeightTable from './WeightTable'

export default WeightTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/WeightTable/index.js